import { render, staticRenderFns } from "./StockProductMovementFilters.vue?vue&type=template&id=6dc22c98"
import script from "./StockProductMovementFilters.vue?vue&type=script&lang=js"
export * from "./StockProductMovementFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports